// extracted by mini-css-extract-plugin
export default {"container":"Header_container__vSi9z","left":"Header_left__dIMjG","right":"Header_right__mq5A8","item":"Header_item__WjJY4","center":"Header_center__Awo8l"};